// extracted by mini-css-extract-plugin
export default {"wrapper":"B4crZr_R_p3L9fzsbLuV","navigation":"sMSiZ4Tr8p4nnAfzglSZ"};